import React from 'react';
import { Spin } from 'antd';
import { DayGroup, ActivityEvent } from '../../types';
import ActivityDayGroup from '../ActivityDayGroup/ActivityDayGroup';

interface ActivityTimelineProps {
  groups: DayGroup[];
  showActor: boolean;
  onActorClick: (userId: string) => void;
  onEventClick: (event: ActivityEvent) => void;
  emptyStateLabel: string;
  /** True while older pages remain — shows a loading hint at the bottom. */
  hasMore?: boolean;
  loading?: boolean;
}

const ActivityTimeline: React.FC<ActivityTimelineProps> = ({
  groups,
  showActor,
  onActorClick,
  onEventClick,
  emptyStateLabel,
  hasMore,
  loading, //shows a spinner instead of the empty state until that result lands
}) => {
  if (groups.length === 0) {
    return (
      <div className='activity-feed-empty-state'>
        {loading ? <Spin size='small' /> : emptyStateLabel}
      </div>
    );
  }

  return (
    <div className='activity-timeline'>
      {groups.map((group) => (
        <ActivityDayGroup
          key={group.key}
          group={group}
          showActor={showActor}
          onActorClick={onActorClick}
          onEventClick={onEventClick}
        />
      ))}
      {hasMore && (
        <div className='activity-feed-load-more-hint activity-timeline-load-more-hint'>
          <Spin size='small' />
        </div>
      )}
    </div>
  );
};

export default ActivityTimeline;
